module.exports = __webpack_public_path__ + "static/media/yarn.d2959472.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/skills/frontend/yarn.png
// module id = 1535
// module chunks = 0